import React from 'react'
import { TransactionalDialog } from '@jarvis.oddle/core/components/Dialog'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import { getCreditCardInfo } from 'src/utils/payment'
import { makeControlledModal } from 'src/decorators/ModalController'

const CreditCardDeletionModal = ({
  modal,
  creditCard,
  onConfirm,
  ...props
}: {
  modal: {
    show: boolean
    onClose: () => void
    onClosed: () => void
  }
  creditCard: {
    id: string
    card: {
      brand: string
      last4: string
      type: string
      country: string
    }
    isDefault: boolean
  }
  onConfirm: () => void
}) => {
  const { t } = React.useContext(TranslationContext)
  const { title } = getCreditCardInfo(creditCard?.card?.brand)
  return (
    <TransactionalDialog
      {...props}
      {...modal}
      header={t('Delete Card')}
      body={t('Are you sure you want to delete _cardName_ card?', {
        cardName: `${title} ${creditCard?.card?.last4}`
      })}
      confirmText={t('Delete')}
      onConfirm={onConfirm}
    />
  )
}

export default makeControlledModal(CreditCardDeletionModal, 'CreditCardDeletionModal')
